import { Box, useMediaQuery, useTheme, Button } from '@mui/material';
import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../styling/styling.css'

const contentBoxStyle = {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' }, // Stack vertically on mobile, horizontally on larger screens
    width: '100%',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    marginBottom: '8%',
    padding: { xs: '1rem', sm: '5%' }, // Adjust padding for mobile and larger screens
    gap: '1rem', // Add spacing between items
};

const textContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    width: { xs: '100%', sm: '70%' }, // Full width on mobile, 70% on larger screens
    margin: { xs: '0', sm: '0 5%' }, // Adjust margins for mobile and larger screens
    textAlign: { xs: 'center', sm: 'left' }, // Center-align text on mobile
};
const descriptionTextStyle = {
    fontFamily: 'IBM Plex Mono',
    fontWeight: '300',
    fontSize: { xs: '0.9rem', sm: '1.1rem' }, // Smaller font size on mobile
    lineHeight: '1.5', // Add spacing between lines
};

const aboutParentContainerStyle = {
    width: '100%',
    minHeight: '75vh',
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    overflowX: 'hidden', // Prevent horizontal scrolling
};
const bottomContainerStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
}

const descriptionHeadingStyle = {
    fontFamily: 'Oswald',
    marginTop: '1%',
    marginBottom: '3%',
    fontSize: { xs: '1.8rem', sm: '2.4rem' }, // Responsive font size
};

const headingBoxStyle = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
    borderRadius: '50px',
    overflow: 'hidden',
    marginBottom: '3%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  justifyContent: 'center',
    // backgroundColor:'grey'
}
function PrivateEvents() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Detect if screen size is mobile

    return (
        <Box sx={aboutParentContainerStyle}>
            <Box sx={headingBoxStyle}>
                <h1 className="pageHeading">LET'S PARTY!</h1>
                <h3
                    className="pageSubHeading"
                    style={{
                        maxWidth: isMobile ? '80%' : '45%', // Adjust width for mobile
                        textAlign: 'center',
                    }}
                >
                    Whether you're looking to host a birthday party, corporate event, family reunion, or girls night - we've got you covered.
                </h3>
            </Box>
            <Box sx={bottomContainerStyle}>
                <Box sx={contentBoxStyle}>
                    <Box sx={textContainerStyle}>
                        <h2 style={descriptionHeadingStyle}>Private Events & Rentals</h2>
                        <p style={descriptionTextStyle}>
                            Our space accommodates up to 50 people and can be booked with or without splatter sessions.
                            We offer flexible booking options for birthdays, corporate gatherings, bridal showers, holiday parties, and more.
                        </p>
                        <p style={{ ...descriptionTextStyle, marginTop: '0.75rem' }}>
                            To book or check availability, call or text us at <strong>270-577-5067</strong>.
                        </p>
                        <Box sx={{ mt: 2 }}>
                            <Button variant="contained" color="secondary" href={`tel:2705775067`}>Book Now</Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default PrivateEvents;
  

